import type { PrevNextNavItemProps } from "./prev-next-nav-item.type";
import type { ButtonProps } from "antd";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export const PrevNextNavButton = <Data = unknown,>({
  type,
  item,
  onClick,
}: PrevNextNavItemProps<Data>) => {
  const { t } = useTranslation();

  const IconName = type === "previous" ? LeftOutlined : RightOutlined;

  const buttonProps: ButtonProps = {
    shape: "circle",
    icon: <IconName aria-label={t(`global:${type}`)} />,
  };

  if (!item) {
    return <Button {...buttonProps} disabled />;
  }

  const { title, disabled } = item;

  return (
    <Tooltip title={title}>
      <Button
        {...buttonProps}
        disabled={disabled}
        onClick={() => onClick?.(item)}
      />
    </Tooltip>
  );
};
